module.exports = __webpack_public_path__ + "static/salesforce-7b6bca970e6a8f94547e063793a1a9e4.svg";